/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ChatroomsCreateDialog extends NoboxEntityDialog<ChatroomsRow, any> {
        protected getFormKey() { return ChatroomsCreateForm.formKey; }
        protected getLocalTextPrefix() { return ChatroomsRow.localTextPrefix; }

        protected form = new ChatroomsCreateForm(this.idPrefix);
        public callback = (response) => {

        }
        constructor() {
            super();
        }

        protected updateInterface() {
            super.updateInterface();
            var setting = JSON.parse($("#ScriptDefault").html());
            this.form.Manual.getGridField().children("input").attr("placeholder", setting.CountryCode + "xxx")
            var listAKun = Q.getLookup("Nobox.AccountLookup").items as unknown as Nobox.AccountRow[];
            var listAKunAutomation = listAKun.filter(yz => yz.Channel == 1);
            if (listAKunAutomation.length > 0)
                this.form.Account.set_value(listAKunAutomation[0].Id.toString());

            this.form.Chat.change(() => {
                var chat = this.form.Chat.get_value();
                if (chat == 1) {
                    this.form.Group.getGridField().toggle(true);
                    this.hideUnhideTo(true)

                    if (this.form.Channel.get_value() == "1")
                        this.form.Account.set_value(null);

                    this.form.Channel.set_value("1");
                } else {
                    this.form.Group.getGridField().toggle(false);
                    this.hideUnhideTo(false)
                }
            })

            var entity = this.get_entity();
            if (entity) {
                if (entity.To == "1") {
                    this.form.Contact.getGridField().toggle(true);
                    this.form.Link.getGridField().toggle(false);
                    this.form.Manual.getGridField().toggle(false);
                } else if (entity.To == "2") {
                    this.form.Contact.getGridField().toggle(false);
                    this.form.Link.getGridField().toggle(true);
                    this.form.Manual.getGridField().toggle(false);
                } else if (entity.To == "3") {
                    this.form.Contact.getGridField().toggle(false);
                    this.form.Link.getGridField().toggle(false);
                    this.form.Manual.getGridField().toggle(true);
                }
            }
            this.form.To.change(() => {
                this.hideUnhideTo(false)
            })
        }

        hideUnhideTo(jikaGrup: boolean) {
            if (jikaGrup) {
                this.form.To.getGridField().toggle(false);
                this.form.Contact.getGridField().toggle(false);
                this.form.Link.getGridField().toggle(false);
                this.form.Manual.getGridField().toggle(false);
            } else {
                this.form.To.getGridField().toggle(true);
                var val = this.form.To.get_value();
                if (val == "1") {
                    this.form.Contact.getGridField().toggle(true);
                    this.form.Link.getGridField().toggle(false);
                    this.form.Manual.getGridField().toggle(false);
                } else if (val == "2") {
                    this.form.Contact.getGridField().toggle(false);
                    this.form.Link.getGridField().toggle(true);
                    this.form.Manual.getGridField().toggle(false);
                } else if (val == "3") {
                    this.form.Contact.getGridField().toggle(false);
                    this.form.Link.getGridField().toggle(false);
                    this.form.Manual.getGridField().toggle(true);
                }
            }
        }

        protected getToolbarButtons() {
            return [];
        }

        protected getDialogButtons() {
            return [
                {
                    text: 'Create',
                    click: () => {
                        if (this.validateForm()) {
                            this.callback({
                                ChId: this.form.Channel.get_value(),
                                AccId: this.form.Account.get_value(),
                                LinkId: this.form.Chat.get_value() == "1" ? null : this.form.Link.get_value(),
                                GrpId: this.form.Chat.get_value() == "1" ? this.form.Group.get_value() : null,
                                Chat: this.form.Chat.get_value(),
                                To: this.form.To.get_value(),
                                Contact: this.form.Contact.get_value(),
                                Manual: this.form.Manual.value,
                                FormTemplateId: this.form.FormTemplateId.value,
                                FormResultId: this.form.FormResultId.value,
                            });
                            this.dialogClose();
                        }
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}